import { Reveal } from "./Reveal";
import { PILLARS, SERVICES, IMAGES } from "../lib/data";
import { ArrowUpRight } from "lucide-react";

export const Practice = () => (
  <section id="practice" className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-36" data-testid="practice-section">
    <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-16">
      <Reveal className="lg:col-span-7">
        <span className="overline">Practice Areas</span>
        <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] mt-5 text-[#F7F5F2] text-balance">
          A dedicated <span className="italic text-[#C8A24B]">criminal</span> law practice — where liberty is defended.
        </h2>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-5">
        <p className="text-[#8C8C8C] leading-relaxed">
          Focused exclusively on criminal litigation before the Punjab &amp; Haryana High Court and subordinate courts — bail, quashing, appeals, NDPS and criminal family matters handled with strategy and courtroom command.
        </p>
      </Reveal>
    </div>

    <div className="grid md:grid-cols-2 lg:grid-cols-3 border-t border-l border-[#262626]">
      {PILLARS.map((p, i) => (
        <Reveal key={p.no} delay={i * 0.1}>
          <div className="group h-full border-b border-r border-[#262626] p-8 lg:p-12 hover-lift hover:bg-[#121212]" data-testid={`pillar-${i}`}>
            <div className="flex items-start justify-between">
              <span className="font-mono text-sm text-[#C8A24B]">{p.no}</span>
              <ArrowUpRight size={22} className="text-[#8C8C8C] group-hover:text-[#C8A24B] transition-colors duration-300" />
            </div>
            <h3 className="font-serif text-3xl lg:text-4xl mt-8 text-[#F7F5F2]">{p.title}</h3>
            <p className="text-[#8C8C8C] leading-relaxed mt-4 max-w-md">{p.desc}</p>
            <div className="flex flex-wrap gap-2 mt-8">
              {p.tags.map((t) => (
                <span key={t} className="text-xs font-mono text-[#8C8C8C] border border-[#262626] rounded-full px-3 py-1.5">
                  {t}
                </span>
              ))}
            </div>
          </div>
        </Reveal>
      ))}
    </div>

    <Reveal delay={0.15}>
      <div className="mt-16 grid md:grid-cols-2 gap-10 items-center border border-[#262626] bg-[#121212] p-8 lg:p-12">
        <div>
          <span className="overline">Also Practising</span>
          <div className="flex flex-wrap gap-x-8 gap-y-4 mt-6">
            {SERVICES.map((s) => (
              <span key={s} className="font-serif text-xl text-[#F7F5F2]/90 border-b border-transparent hover:border-[#C8A24B] transition-colors duration-300">
                {s}
              </span>
            ))}
          </div>
        </div>
        <div className="relative aspect-[4/3] overflow-hidden">
          <img src={IMAGES.justice} alt="Statue of justice" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" />
          <div className="absolute inset-0 ring-1 ring-inset ring-[#262626]" />
        </div>
      </div>
    </Reveal>
  </section>
);
